<template>
  <div id="app" :nowLang="nowLangx">
    <Header v-show="hasHeader"></Header>
    <router-view></router-view>
    <Footer v-show="hasFooter"></Footer>
  </div>
</template>

<script>

import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'

import {mapGetters} from 'vuex'
import axios from 'axios'
import {BACKEND_LOCATION} from '@api/Endpoints'


// import axios from 'axios'

export default {
  name: 'app',
  data(){
    return{
      hasHeader: true,
      hasFooter: true,
      noHeader:['experience'],
      noFooter:['payment', 'experience'],
      noHeaderMb:['payment', 'experience'],
      noFooterMb:['experience'],
      deviceModel: 'pc',
      isMobile: false
    }
  },
  components: {
    Header,
    Footer
  },
  watch:{
    '$route'(){
      this.filterCompent(this.$route.name)
    }
  },
  methods:{
    filterCompent(name){
      if(!this.isMobile){
        this.hasHeader = !~this.noHeader.indexOf(name)
        this.hasFooter = !~this.noFooter.indexOf(name)
      }else {
        this.hasHeader = !~this.noHeaderMb.indexOf(name)
        this.hasFooter = !~this.noFooterMb.indexOf(name)
      }
    },
    getDevice: function(){
      window.addEventListener('resize',this.windowRes)
      this.windowRes()
    },
    windowRes: function(){
      const $this = this
      if($this.deviceModel === 'mb' && document.body.clientWidth > 996) {
        $this.isMobile = false
        $this.deviceModel = 'pc'
        $this.filterCompent(this.$route.name)
      }else if ($this.deviceModel === 'pc' && document.body.clientWidth <= 996){
        $this.isMobile = true
        $this.deviceModel = 'mb'
        $this.filterCompent(this.$route.name)
      }  
    },
    setLangList(list){
      this.$store.dispatch('setLangList', list)
    },
  },
  beforeCreate() {
    const $this = this
    const api = BACKEND_LOCATION.api + 'lang'
    axios.post(api)
    .then(function (response) {
      const res = response.data
      const code = res.code
      switch(code){
        case "100":
          $this.setLangList(res.lang)
          break
        default:
          console.log('error')
          break
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  },
  mounted(){
    this.getDevice()
    this.filterCompent(this.$route.name)
  },
  computed:{
    ...mapGetters(['nowLangx'])
  }
}
</script>
